module.exports = __webpack_public_path__ + "static/media/loc7_img1.2d3f8c9b.jpg";